import ChatBody from "./ChatBody";
export default ChatBody;
